import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useProgressStore } from "@/store/progressStore";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import Home from "@/features/home/Home";
import Challenge from "@/features/challenge/Challenge";
import Interview from "@/features/interview/Interview";
import Jam from "@/features/jam/Jam";
import Triage from "@/features/triage/Triage";
import Docs from "@/features/docs/Docs";
import Library from "@/features/library/Library";
import Dashboard from "@/features/dashboard/Dashboard";
import History from "@/features/history/History";
import Customize from "@/features/customize/Customize";
import Settings from "@/features/settings/Settings";
import NotFound from "@/features/misc/NotFound";

const pageVariants = {
  initial: { opacity: 0, y: 12 },
  enter: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
};

export default function App() {
  const location = useLocation();
  const loadProgress = useProgressStore((s) => s.load);

  // Hydrate progress (XP/streak) from local storage on startup.
  useEffect(() => {
    loadProgress();
  }, [loadProgress]);

  return (
    <div className="flex h-full w-full overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-y-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              variants={pageVariants}
              initial="initial"
              animate="enter"
              exit="exit"
              transition={{ duration: 0.22, ease: "easeOut" }}
              className="mx-auto w-full max-w-6xl px-5 py-8"
            >
              <Routes location={location}>
                <Route path="/" element={<Home />} />
                <Route path="/challenge" element={<Challenge />} />
                <Route path="/interview" element={<Interview />} />
                <Route path="/jam" element={<Jam />} />
                <Route path="/triage" element={<Triage />} />
                <Route path="/docs" element={<Docs />} />
                <Route path="/library" element={<Library />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/history" element={<History />} />
                <Route path="/customize" element={<Customize />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
